import { Column } from '@devexpress/dx-react-grid';

export const columns: Column[] = [
  { name: 'schemeCode', title: 'Formal/Scheme Code' },
  { name: 'siteCode', title: 'Site Code' },
];
